export class Metrics {
  handlers = [];
  availableMethods = ['addToTrace', 'registerEvent', 'registerError', 'setPageName'];

  constructor() {
    this.configureMetrics();
  }

  use = (handler) => {
    this.handlers.push(handler);
    return this;
  };

  configureMetrics = () => {
    const noop = (() => ({}));
    const dispatchToHandlers = method => args => this.handlers.forEach(h => (h[method] || noop)(args));

    this.availableMethods.forEach((method) => {
      this[method] = dispatchToHandlers(method);
    });
  };
}

export default new Metrics();
